import React from 'react';
import { Box, Typography, Paper, Avatar, makeStyles } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
import { Agent } from './types';
import { getAgentIcon } from './utils';

const useStyles = makeStyles(theme => ({
  agentCard: {
    borderRadius: '15px',
    padding: theme.spacing(2),
    margin: theme.spacing(1, 0),
    cursor: 'pointer',
    border: `2px solid transparent`,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  agentCardSelected: {
    borderColor: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.light + '20',
  },
  agentInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  avatar: {
    width: 36,
    height: 36,
    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.15)',
    border: `2px solid ${theme.palette.background.paper}`,
  },
}));

interface AgentsTabProps {
  agents: Agent[];
  selectedAgent: string;
  onAgentSelect: (agentName: string) => void;
  basePath?: string;
}

export const AgentsTab: React.FC<AgentsTabProps> = ({
  agents,
  selectedAgent,
  onAgentSelect,
  basePath = '/marketplace/home/agent-chat',
}) => {
  const classes = useStyles();
  const navigate = useNavigate();

  const handleAgentClick = (agent: Agent) => {
    navigate(`${basePath}/${agent.apiName || agent.name.toLowerCase().replace(/\s+/g, '-')}`, { replace: true });
    onAgentSelect(agent.name);
  };

  return (
    <Box>
      {agents.map(agent => (
        <Paper
          key={agent.name}
          className={`${classes.agentCard} ${selectedAgent === agent.name ? classes.agentCardSelected : ''}`}
          onClick={() => handleAgentClick(agent)}
        >
          <Box className={classes.agentInfo}>
            <Avatar
              className={classes.avatar}
              style={{ backgroundColor: agent.color }}
            >
              {getAgentIcon(agent.icon)}
            </Avatar>
            <Box>
              <Typography variant="subtitle1">{agent.name}</Typography>
            </Box>
          </Box>
        </Paper>
      ))}
    </Box>
  );
};
